import * as React from 'react';
import Alert, { AlertCategoryEnum } from '../misc/components/Alert';
import { Column, Table } from '../Components/QueryTable';
import { useQuery } from '../Components/Query';
import { SortHeader } from '../Components/SortHeader';
import { useWebPortalApiClient, useWebPortalLegacyClient } from '../misc/api/WebPortalTokenClient';
import { FileDownload } from '../misc/FileDownload';

interface DocumentsWidgetTableProps {
    allStudySelected: boolean;
}

export const DocumentsWidgetTable = ({ allStudySelected }: DocumentsWidgetTableProps) => {

    const { data } = useQuery();
    const client = useWebPortalApiClient();
    const legacyClient = useWebPortalLegacyClient();

    const downloadFile = async (fileId: string) => {
        const fileRecord = await client.client.getFile(fileId);
        const fileResult = await legacyClient.downloadFile(fileId);

        FileDownload(fileResult, fileRecord.fileName);
    }

    const menuFormatter = (value) => {
        if (value !== null && value !== undefined)
            return (
                <div className="text-center">
                    <div className="btn-group" role="group">
                        <button type="button" className="btn btn-primary btn-xs dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i className="fas fa-bars" aria-hidden="true" />
                        </button>
                        <ul className="dropdown-menu scrollable-menu" role="menu">
                            <li key="key_">
                                <a onClick={() => downloadFile(value.id)}>View</a>
                            </li>
                        </ul>
                    </div>
                </div>
            );
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="table-responsive" data-automationid="DocumentsTable">

                            { allStudySelected ?
                                (
                                    <Alert category={AlertCategoryEnum.Danger} show={true}>
                                        Please select a specific study to view the documents for that study
                                    </Alert>
                                ) : (
                                    <Table automationId="documentsTable" data={data}>
                                        <Column field="fileName" header={<SortHeader title="File Name" field="fileName" />} />
                                        <Column field="" formatter={menuFormatter} />
                                    </Table>
                                )
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
